"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.humanReadableScore = humanReadableScore;
exports.getResults = getResults;
exports.getScales = getScales;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.ALLIANZ_STRESS;

var likelihoodFn = function likelihoodFn(n) {
  return n * 100 / (likelihood.length - 1);
};

var daySlider = ["0", "1", "2", "3", "4", "5", "6", "7"];
var likelihood = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
var stressOptions = ["Never", "Almost Never", "Sometimes", "Fairly Often", "Very Often"];
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  options: daySlider
};
var stressQuestions = [// STRESS - 5 questions
{
  prompt: "Stress is when someone feels <b>tense, restless, nervous, anxious or is unable " + "to sleep</b> because their mind is troubled. Do you feel this type of stress?",
  options: stressOptions,
  aggregated: true,
  key: "stressLevel",
  type: "radio",
  specific: true,
  batteryId: "ALLIANZ_STRESS",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "How many days in the last week did you <b>miss work, class or daily activities</b> due to mental or" + " physical health reasons (e.g. stress, fatigue, illness)?",
  options: daySlider,
  aggregated: true,
  key: "roiAbsenteeismDays",
  type: "slider",
  specific: true,
  batteryId: "ALLIANZ_STRESS",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "On how many days in the last week did you feel so <b>impaired by stress</b>," + " that even though you went about your daily activities, your productivity was reduced?",
  options: daySlider,
  aggregated: true,
  type: "slider",
  key: "roiPresenteeismDays",
  specific: true,
  batteryId: "ALLIANZ_STRESS",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "On how many days in the past week have you felt so <b>stressed</b> or" + " <b>frustrated</b> that you considered changing work or dropping out of your studies?",
  options: daySlider,
  aggregated: true,
  key: "roiTurnoverRiskDays",
  type: "slider",
  specific: true,
  batteryId: "ALLIANZ_STRESS",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "How likely are you to recommend your institution to a friend as a great place to work or study?",
  extraText: "",
  type: "slider",
  options: likelihood,
  key: "npsWork",
  eval: likelihoodFn,
  batteryId: "ALLIANZ_STRESS"
}];

function humanReadableScore(pssScore) {
  var summaryString = "Much Lower than Average";

  if (pssScore > 30) {
    summaryString = "Slightly Lower than Average";
  }

  if (pssScore > 42) {
    summaryString = "Average";
  }

  if (pssScore > 57) {
    summaryString = "Slightly Higher than Average";
  }

  if (pssScore > 70) {
    summaryString = "Much Higher than Average";
  }

  return summaryString;
}

var questions = (0, _utils.wrapBattery)(stressQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var stressLevelScore = answers[0] * 17;
  var roiAbsenteeismDaysScore = answers[1] / 7 * 5;
  var roiPresenteeismDays = answers[2] / 7 * 5;
  var roiTurnoverRiskDays = answers[3] / 7 * 5;
  var score = Math.round(stressLevelScore + roiAbsenteeismDaysScore + roiPresenteeismDays + roiTurnoverRiskDays);
  var humanReadable = {
    STRESS: "".concat(score, " (").concat(humanReadableScore(score), ")")
  };
  return {
    STRESS_SCORE: score,
    STRESS_1: answers[0],
    STRESS_2: answers[1],
    STRESS_3: answers[2],
    STRESS_4: answers[3],
    STRESS_5: answers[4],
    humanReadable: humanReadable
  };
}

function getScales() {
  var scales = {
    STRESS: "Much Lower than Average (0-30), Slightly Lower than Average (31-42), Average (43-57), Slightly Higher than Average (58-70), Much Higher than Average (71-100)"
  };
  return scales;
}